module.exports = __webpack_public_path__ + "static/media/20ECE28.03679170.jpg";